export default __webpack_public_path__ + "static/logo-alicja-black-dd0846cb526b3cd5fa0dc901edd47c25.svg";